import { generateClient } from "aws-amplify/api";

import { gqlQueryJobHeaderServices } from "../../graphql/query.job.header.services";

const gqlclient = generateClient();

const getData = async ({ user_id, next_token = null }) => {
  const res = await gqlclient.graphql({
    query: gqlQueryJobHeaderServices,
    variables: { user_id, next_token },
  });
  const { errors, data } = res;
  if (errors) {
    throw Error(errors[0].message);
  }
  return data.listJobHeaderServices;
};

const handler = async ({ user_id, next_token = null }, { rejectWithValue }) => {
  try {
    const res = await getData({ user_id, next_token });
    return res; // { items, nextToken }
  } catch (error) {
    console.error("services.customers.getCustomerJobs@handler", error);
    return rejectWithValue(error.message || "Failed to load jobs");
  }
};

export default { handler };
